<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('monthly-semester-mapping.title') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('monthly-semester-mapping.title'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button color="info" outline @click="addNew">
              {{ $t('add_new') }}
            </ts-button>
          </div>
        </div>
        <div class="overflow-auto ts-mt-4">
          <Table
            :columns="columns"
            :data="resources"
            :loading="loading"
            max-height="700"
            stripe
            highlight-row
            size="small"
            ref="selection"
          >
            <template slot-scope="{ row }" slot="months">
              <span v-for="(month, index) in row.months" :key="index">
                {{ getMonthName(month) }}
              </span>
            </template>
            <template slot-scope="{ row }" slot="remark">
              <span>{{ row.remark }}</span>
            </template>
            <template slot-scope="{ row }" slot="modified_name_by">
              <span>{{ row.modified_name_by }}</span>
            </template>
            <template slot-scope="{ row }" slot="modified_date">
              <span>{{ row.modified_date }}</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="mr-2 text-primary"
                @click.prevent="onClickEdit(row)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="topLeft"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="confirmDelete(row)"
              >
                <template slot="title">
                  <p>
                    {{ $t('monthly-semester-mapping.confirmation.delete') }}
                  </p>
                  <p>
                    {{
                      $t('monthly-semester-mapping.confirmation.delete_warning')
                    }}
                  </p>
                </template>
                <a
                  href="#"
                  v-tooltip="$t('delete')"
                  class="mr-2 text-danger"
                  :disabled="row._deleting"
                >
                  <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                  <i class="fas fa-trash" v-else></i>
                </a>
              </a-popconfirm>
            </template>
          </Table>
        </div>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination
            v-model="pagination"
            @navigate="fetchData"
          ></ts-pagination>
        </div>
      </ts-card-wrapper>
    </ts-card>

    <a-modal
      :title="$t('monthly-semester-mapping.title')"
      v-if="showForm"
      :visible="showForm"
      @ok="closeForm"
      @cancel="closeForm"
      width="500px"
      :footer="null"
    >
      <monthly-semester-mapping-form
        :edit-data="editData"
        @close="closeForm"
      ></monthly-semester-mapping-form>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MonthlySemesterMappingForm from './form.vue'
import notificationAlert from '@/utils/NotificationAlert'
export default {
  name: 'MonthlySemesterMapping',
  components: {
    MonthlySemesterMappingForm
  },
  data() {
    return {
      loading: false,
      showForm: false,
      editData: undefined
    }
  },
  mounted() {
    // Fetch data when the component is mounted
    this.fetchData()
  },
  computed: {
    ...mapState('monthlySemesterMapping', [
      'resources',
      'pagination',
      'studentStatus'
    ]),
    getMonthName: () => number => {
      if (number == null || number == undefined) return ''
      const monthNames = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
      ]
      return monthNames[number - 1]
    },
    columns() {
      return [
        {
          title: this.$t('monthly-semester-mapping.columns.sub_program'),
          key: 'acps_name'
        },
        {
          title: this.$t('monthly-semester-mapping.columns.semester_order'),
          key: 'semester_order',
          className: 'text-center'
        },
        {
          title: this.$t('monthly-semester-mapping.columns.month'),
          slot: 'months'
        },
        {
          title: this.$t('monthly-semester-mapping.columns.remark'),
          key: 'remark'
        },
        {
          title: this.$t('monthly-semester-mapping.columns.modified_by'),
          key: 'modified_name_by'
        },
        {
          title: this.$t('monthly-semester-mapping.columns.modified_at'),
          key: 'modified_date'
        },
        {
          title: this.$t('actions'),
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 200
        }
      ]
    }
  },
  methods: {
    ...mapActions('monthlySemesterMapping', ['fetch', 'onDelete']),
    addNew() {
      this.showForm = true
    },
    closeForm() {
      this.showForm = false
      this.editData = undefined
      this.fetchData()
    },
    async fetchData(attributes = {}) {
      this.loading = true
      return await this.fetch(attributes)
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmDelete(row) {
      this.loading = true
      this.onDelete(row.id)
        .then(async response => {
          notificationAlert(response)
          await this.fetchData()
        })
        .catch(error => {
          notificationAlert(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClickEdit(row) {
      this.editData = row
      this.showForm = true
    }
  }
}
</script>
